import React from 'react';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p className="footer-text">
          © 2026 made with ❤️ by{' '}
          <a 
            href="https://www.1system.us/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            https://www.1system.us/
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;